import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class CtvBorcKontrolAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "CtvBorcKontrol";
        super(baseUrl);
    }
    getCtvBorcKontrol(SqId: number, Durum: number) {
        var request = new CtvBorcKontrolRequest(SqId, Durum);

        return this.post("", request, false);
    }
}
export default new CtvBorcKontrolAPI();
class CtvBorcKontrolRequest {
    public sqId: number;
    public durum: number;

    constructor(sqId: number, durum: number) {

        this.sqId = sqId;
        this.durum = durum;

    }


}
export { CtvBorcKontrolRequest };